// Copy for a scanned QR no e-label provider reads yet (docs/elabel-providers.md, "Unseen sources"):
// the plain "not supported yet" message, what was passed on, and the "ask us" action. One entry per
// locale; every key exists in all seven (nl is the source, the rest are translations).
export const unseenCopy = {
  nl: {
    "scan.unseen.title": "Deze bron ondersteunen we nog niet",
    "scan.unseen.body":
      "Deze QR-code verwijst naar {host}. proef kan daar nog geen e-label van lezen. Alleen de naam van de site is doorgegeven, nooit de volledige link of wie je bent.",
    "scan.unseen.ask": "Vraag ons dit te ondersteunen",
    "scan.unseen.asked": "Bedankt, we hebben genoteerd dat je deze bron wilt.",
    "scan.unseen.failed": "Dat is niet gelukt. Probeer het later opnieuw.",
  },
  en: {
    "scan.unseen.title": "We don't support this source yet",
    "scan.unseen.body":
      "This QR code leads to {host}, and proef cannot read e-labels from there yet. Only the site's name was passed on, never the full link or who you are.",
    "scan.unseen.ask": "Ask us to support this",
    "scan.unseen.asked": "Thanks, we have noted that you want this source.",
    "scan.unseen.failed": "That did not go through. Try again later.",
  },
  de: {
    "scan.unseen.title": "Diese Quelle unterstützen wir noch nicht",
    "scan.unseen.body":
      "Dieser QR-Code führt zu {host}, und proef kann dort noch keine E-Labels lesen. Weitergegeben wurde nur der Name der Seite, nie der vollständige Link oder wer du bist.",
    "scan.unseen.ask": "Bitte um Unterstützung",
    "scan.unseen.asked": "Danke, wir haben notiert, dass du diese Quelle willst.",
    "scan.unseen.failed": "Das hat nicht geklappt. Versuche es später noch einmal.",
  },
  fr: {
    "scan.unseen.title": "Nous ne prenons pas encore en charge cette source",
    "scan.unseen.body":
      "Ce QR code mène à {host}, et proef ne sait pas encore y lire d'e-label. Seul le nom du site a été transmis, jamais le lien complet ni qui tu es.",
    "scan.unseen.ask": "Demande-nous de la prendre en charge",
    "scan.unseen.asked": "Merci, nous avons noté que tu veux cette source.",
    "scan.unseen.failed": "Ça n'a pas marché. Réessaie plus tard.",
  },
  es: {
    "scan.unseen.title": "Todavía no admitimos esta fuente",
    "scan.unseen.body":
      "Este código QR lleva a {host}, y proef aún no puede leer e-labels de ahí. Solo se envió el nombre del sitio, nunca el enlace completo ni quién eres.",
    "scan.unseen.ask": "Pídenos que la admitamos",
    "scan.unseen.asked": "Gracias, hemos anotado que quieres esta fuente.",
    "scan.unseen.failed": "No ha funcionado. Inténtalo de nuevo más tarde.",
  },
  it: {
    "scan.unseen.title": "Questa fonte non è ancora supportata",
    "scan.unseen.body":
      "Questo codice QR porta a {host}, e proef non sa ancora leggere le e-label da lì. È stato inviato solo il nome del sito, mai il link completo né chi sei.",
    "scan.unseen.ask": "Chiedici di supportarla",
    "scan.unseen.asked": "Grazie, abbiamo annotato che vuoi questa fonte.",
    "scan.unseen.failed": "Non è andata a buon fine. Riprova più tardi.",
  },
  pt: {
    "scan.unseen.title": "Ainda não suportamos esta fonte",
    "scan.unseen.body":
      "Este código QR leva a {host}, e o proef ainda não consegue ler e-labels de lá. Só o nome do site foi enviado, nunca o link completo nem quem és.",
    "scan.unseen.ask": "Pede-nos para a suportar",
    "scan.unseen.asked": "Obrigado, anotámos que queres esta fonte.",
    "scan.unseen.failed": "Não correu bem. Tenta de novo mais tarde.",
  },
} as const;
